
// @ts-nocheck


export const localeCodes =  [
  "en",
  "zh-TW",
  "es"
]

export const localeLoaders = {
  en: [
    {
      key: "locale_en_46ts_69141e4b",
      load: () => import("#nuxt-i18n/69141e4b" /* webpackChunkName: "locale_en_46ts_69141e4b" */),
      cache: true
    }
  ],
  "zh-TW": [
    {
      key: "locale_zh_45TW_46ts_79851675",
      load: () => import("#nuxt-i18n/79851675" /* webpackChunkName: "locale_zh_45TW_46ts_79851675" */),
      cache: true
    }
  ],
  es: [
    {
      key: "locale_es_46ts_d9b118ec",
      load: () => import("#nuxt-i18n/d9b118ec" /* webpackChunkName: "locale_es_46ts_d9b118ec" */),
      cache: true
    }
  ]
}

export const vueI18nConfigs = [
  () => import("#nuxt-i18n/8490e796" /* webpackChunkName: "config_i18n_46config_46ts_8490e796" */)
]

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: false
  },
  compilation: {
    strictMessage: true,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "en",
      name: "English",
      language: "en-US",
      files: [
        "/builds/andy.c/gsn-frontend/i18n/locales/en.ts"
      ]
    },
    {
      code: "zh-TW",
      name: "繁體中文",
      language: "zh-TW",
      files: [
        "/builds/andy.c/gsn-frontend/i18n/locales/zh-TW.ts"
      ]
    },
    {
      code: "es",
      name: "Español",
      language: "es-ES",
      files: [
        "/builds/andy.c/gsn-frontend/i18n/locales/es.ts"
      ]
    }
  ],
  defaultLocale: "en",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "no_prefix",
  lazy: true,
  langDir: "locales",
  rootRedirect: undefined,
  detectBrowserLanguage: {
    alwaysRedirect: false,
    cookieCrossOrigin: false,
    cookieDomain: null,
    cookieKey: "i18n_redirected",
    cookieSecure: false,
    fallbackLocale: "en",
    redirectOn: "root",
    useCookie: true
  },
  differentDomains: false,
  baseUrl: "",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "en",
    name: "English",
    language: "en-US",
    files: [
      {
        path: "/builds/andy.c/gsn-frontend/i18n/locales/en.ts",
        cache: undefined
      }
    ]
  },
  {
    code: "zh-TW",
    name: "繁體中文",
    language: "zh-TW",
    files: [
      {
        path: "/builds/andy.c/gsn-frontend/i18n/locales/zh-TW.ts",
        cache: undefined
      }
    ]
  },
  {
    code: "es",
    name: "Español",
    language: "es-ES",
    files: [
      {
        path: "/builds/andy.c/gsn-frontend/i18n/locales/es.ts",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/